import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToolsService } from '../../sb-editor-tools/services/tools.service';
import { Logo, MinisiteConfiguration } from '@3ddv/ngx-sites-builder-lib';
import { SafeUrl } from '@angular/platform-browser';
import { SbApiService } from 'src/app/sites-builder/services/sb-api.service';
import { apiSiteGetResponse, SiteModel } from 'src/app/sites-builder/models/site.model';
import { environment } from 'src/environments/environment';
import { Workflow } from '@3ddv/ngx-sites-builder-lib/lib/workflows/models/workflow.model';
import { ClientModel } from 'src/app/shared/models/client.model';
import { ClientListFromKeys } from 'src/app/auth/private/components/client/models/client.model';
import { CdVenueModel } from 'src/app/content-distribution/private/entities/venues/models/venue.model';
import { SaveMinisiteService } from '../../services/save-minisite.service';
import { dbSiteConfiguration } from '../../models/minisite.model';

@Component({
  selector: 'app-save-minisite',
  templateUrl: './save-minisite.component.html',
  styleUrls: ['./save-minisite.component.scss'],
})
export class SaveMinisiteComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public closeReason: 'success' | 'cancel';
  public sitealreadyExists: apiSiteGetResponse = null;
  public checkdeleteconfirm: boolean = false;
  public deletingSite: boolean = false;
  public checkedSite: boolean = false;
  public mode: 'edit' | 'create' = 'create';
  // Site flags
  public enableSiteOnPublish: boolean;
  public siteFlags: { editorMap: boolean; testMap: boolean };
  // select client
  public clientList: Array<ClientModel> = [];
  public selectedClient: Array<ClientModel> = [];
  public dropdownSettings = {
    idField: 'key',
    textField: 'name',
  };
  // From initial state: sb-editor.component.ts
  public minisiteConfiguration: MinisiteConfiguration;
  public minisiteDB?: SiteModel;
  public workflow: Workflow;
  public venue: CdVenueModel;
  public authClients: ClientListFromKeys[];
  public libVersion: string;

  //URL donde se publicará el site: 3ddigitalvenue.com/:client
  public client: string;
  public logoPreview: SafeUrl;
  public faviconPreview: SafeUrl;

  constructor(
    private bsModalRef: BsModalRef,
    private toolsService: ToolsService,
    private sbapiService: SbApiService,
    private saveMninisiteService: SaveMinisiteService
  ) {
    this.subscriptions = [];
    console.log('Venue: ', this.venue);
  }

  ngOnInit(): void {
    this.mode = 'create';
    this.client = this.minisiteConfiguration.mapConfig.client;

    // Site flags init
    this.enableSiteOnPublish = false;
    this.siteFlags = {
      editorMap: false,
      testMap: false,
    };

    if (this.minisiteDB) {
      console.log('MinisiteDB: ', this.minisiteDB);
      this.mode = 'edit';
      // Published/Active: 'is_active'
      this.enableSiteOnPublish = this.minisiteDB.is_active;
      this.siteFlags.editorMap = this.minisiteDB.editor2dmapsdemo;
      this.siteFlags.testMap = this.minisiteDB.isTest;

      // console.log(this.enableSiteOnPublish);
      // console.log(this.siteFlags.editorMap);
      // console.log(this.siteFlags.testMap);

      this.selectedClient = this.authClients.filter(x => (x.key === this.minisiteDB.client_key ? x : null));
      console.log('Selected client: ', this.selectedClient);
    }

    this.showLogo();
    this.showFavicon();
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  private showLogo() {
    const logoTool = this.minisiteConfiguration.toolsConfig.logo;
    if (logoTool.file) {
      const reader = new FileReader();
      reader.readAsDataURL(logoTool.file);
      reader.onload = _event => {
        this.logoPreview = reader.result;
      };
    } else if (logoTool.path && this.client) {
      this.logoPreview = environment.sitesBuilder.staticrsc_cdn + this.client + logoTool.path;
      // console.log(this.logoPreview);
    } else if (this.isLogoType(logoTool) && logoTool.default) {
      this.logoPreview = '/assets/img/3ddv/3ddv.png';
    }
  }

  private showFavicon() {
    const tool = this.minisiteConfiguration.toolsConfig.favicon;
    if (!tool.file && !tool.path) {
      this.faviconPreview = '/assets/img/3ddv/favicon-3ddv.png';
    }

    if (tool.file) {
      const reader = new FileReader();
      reader.readAsDataURL(tool.file);
      reader.onload = _event => {
        this.faviconPreview = reader.result;
      };
    } else if (tool.path && this.client) {
      this.faviconPreview = environment.sitesBuilder.staticrsc_cdn + this.client + tool.path;
    }
  }

  public isLogoType(x: unknown): x is Logo {
    if (!x) return false;
    if (typeof (x as any).default === 'boolean') return true;
    return false;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public onDismiss(reason: 'cancel') {
    this.closeReason = reason;
    this.bsModalRef.hide();
  }

  public checkIfExists() {
    // Check if site already exists
    this.sitealreadyExists = null;
    this.checkdeleteconfirm = false;
    this.checkedSite = false;
    const site$ = this.sbapiService.getSiteByTitle(this.client).subscribe(res => {
      if (res.site) {
        this.sitealreadyExists = res;
      } else {
        this.checkedSite = true;
        this.sitealreadyExists = null;
      }
    });
    this.subscriptions.push(site$);
  }

  public onConfirm(mode: 'create' | 'edit') {
    if (mode === 'edit') {
      this.createFormData();
    } else if (mode === 'create') {
      // Check if site already exists
      this.sitealreadyExists = null;
      const site$ = this.sbapiService.getSiteByTitle(this.client).subscribe({
        next: (res) => {
          this.checkdeleteconfirm = false;
          this.sitealreadyExists = res;
        },
        error: (err) => {
          this.checkdeleteconfirm = false;
          console.error(err)
          this.sitealreadyExists = null;
          this.createFormData();
        },
      })
      this.subscriptions.push(site$);
    }
  }

  public createFormData() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      // console.log(res);
      // Prepare MinisiteConfiguration to add to form
      this.minisiteConfiguration.mapConfig.client = this.client;
      // this.minisiteConfiguration.mapConfig.enabled = Boolean(this.enableSiteOnPublish);
      this.minisiteConfiguration.mapConfig.enabled = this.enableSiteOnPublish;
      this.minisiteConfiguration.toolsConfig = Object.assign({}, res);

      // Prepare DB data to add to form
      const dbData: dbSiteConfiguration = {
        client_key: this.selectedClient[0].key,
        venue_key: this.venue.key,
        // template_color_id: ,
        // template_map_id: ,
        workflow_id: this.minisiteConfiguration.mapConfig.workflow_id.toString(),
        title: this.minisiteConfiguration.mapConfig.client,
        url: environment.sitesBuilder.app_url + this.minisiteConfiguration.mapConfig.client,
        venue_code: this.minisiteConfiguration.mapConfig.venue_id,
        map_id: this.minisiteConfiguration.mapConfig.map_id,
        is_active: this.enableSiteOnPublish,
        editor2dmapsdemo: this.siteFlags.editorMap,
        isTest: this.siteFlags.testMap,
        libVersion: this.libVersion,
      };
      console.log('(Create formdata) MinisiteConfiguration', this.minisiteConfiguration);

      // Form Data
      const formData: FormData = this.saveMninisiteService.siteDataToForm(dbData, this.minisiteConfiguration);
      console.log(formData);

      // Create/Update site, sending the form (formData) as body
      let post$;
      if (this.mode === 'create') {
        post$ = this.sbapiService.createSite(formData).subscribe(res => {
          if (res.site) {
            this.closeReason = 'success';
            this.bsModalRef.hide();
          }
        });
      } else if (this.mode === 'edit') {
        post$ = this.sbapiService.updateSite(this.minisiteDB.id, formData).subscribe(res => {
          if (res.site) {
            this.closeReason = 'success';
            this.bsModalRef.hide();
          }
        });
      }
      this.subscriptions.push(post$);
    });
    this.subscriptions.push(tools$);
  }

  public deletesite(id: number) {
    this.deletingSite = true;
    const delete$ = this.sbapiService.deleteSite(id).subscribe(res => {
      this.deletingSite = false;
      this.checkdeleteconfirm = false;
      this.sitealreadyExists = null;
    });
    this.subscriptions.push(delete$);
  }
}
